import {
  FaGooglePlay as Android,
  FaAppStoreIos as Apple,
  FaGlobe as Globe,
} from 'react-icons/fa';
const PlatformAvailabilitySection = () => {
  const platforms = [
    {
      icon: <Globe className='md:size-10 size-7' />,

      link: '#',
    },
    {
      icon: <Apple className='md:size-11 size-7' />,

      link: '#',
    },
    {
      icon: <Android className='md:size-10 size-7' />,

      link: '#',
    },
  ];

  return (
    <div className='bg-gradient-to-r from-legal-dark-blue via-legal-dark-gray to-legal-dark-blue text-white flex items-center h-full py-10 '>
      <div className='max-w-5xl flex flex-col items-center gap-4 mx-auto px-4'>
        <span className='text-2xl md:text-4xl text-center font-medium font-marcellus text-legal-brown'>
          We are Available on
        </span>
        <div className='flex items-center justify-center space-x-8'>
          <div className='flex items-center gap-24'>
            {platforms.map((platform, index) => (
              <a
                key={index}
                href={platform.link}
                className='flex items-center space-x-2 hover:text-blue-200 transition-colors duration-200'
              >
                {platform.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformAvailabilitySection;
